import { render, staticRenderFns } from "./OrderHistoryBox.vue?vue&type=template&id=3a0509bc&"
import script from "./OrderHistoryBox.vue?vue&type=script&lang=js&"
export * from "./OrderHistoryBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports